import axios   from "axios";
// import Swal    from "sweetalert2";
import Toaster from "./toaster";


axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};


export default class AdfConnected
{
    constructor ()
    {
        this.isSearchPage = document.querySelector('body').classList.contains('search-page');

        this.createClosure();
        this.bindEvents();
    }

    createClosure ()
    {
        this.fctHighlightOneResource = this.highlightOneResource.bind(this);
        this.fctGetUserInfo = this.getUserInfo.bind(this);
        this.fctGetUserFavourites = this.bindUserFavouritesButtons.bind(this);
        this.fctShowUserFavourites = this.onShowUserFavourite.bind(this);
    }

    bindEvents ()
    {
        window.addEventListener("close-add-resource", this.fctHighlightOneResource); //the event close-add-resource is called from a Vue module (AddResource.vue)
        window.addEventListener("on-user-info", this.fctGetUserInfo );
        window.addEventListener("on-user-favourites", this.fctGetUserFavourites);
        window.addEventListener("show-favourite", this.fctShowUserFavourites);
    }

     getUserInfo (event)
    {
        //let response = await axios.get("/endpoints/user");

        let payload = event.detail;

        //commit("user", response.data.success ? response.data : {user: null})
        if (payload.success)
        {
            window.__USER__ = payload.user;

            let face = document.querySelector(".fa-circle-user");
            face.classList.remove("fa-light");
            face.classList.add("fa-solid");
        }
        else
        {
            window.__USER__ = null;
        }

        return window.__USER__;

    }

    bindUserFavouritesButtons (event)
    {
        if (!event)
            return;

        let favourites = event.detail;


        if (window.__login__)
        {
            window.__login__.setFavourites(favourites);
        }

        if (!this.isSearchPage) //in the search page, the Vue module will take care of this
        {
            let strSelector = "button.favourite";


            let btnFavourites = Array.from(document.querySelectorAll(strSelector));

            btnFavourites.forEach( btn => btn.addEventListener("click", (e) => this.onFavouriteClick(e.target, e)));

            this.highlightFavourites(favourites);

        }
        else
        {
            let strSelector = ".resources-last-seen button.favourite";

            let btnFavourites = Array.from(document.querySelectorAll(strSelector));

            btnFavourites.forEach( btn => btn.addEventListener("click", (e) => this.onFavouriteClick(e.target, e)));

            window.__setFavourites__(favourites); //this is called IN the Vue Search App.vue

        }



    }

    highlightFavourites (favourites)
    {
        let allResources = favourites.map ( folder => folder.resources).flat();
        let btnFavourites = Array.from(document.querySelectorAll("button.favourite"));

        let currentFavourites = btnFavourites.filter ( btn => allResources.includes(parseInt(btn.attributes["data-resource-id"].value)));

        currentFavourites.forEach( btn => btn.classList.add("active"));

    }

    highlightOneResource (event)
    {
        let count = event.detail.count;
        let id = event.detail.resourceId;

        let strSelector = "[data-resource-id='" + id + "']";
        Array.from(document.querySelectorAll(strSelector))
             .forEach( btn =>
                       {
                            count > 0 ? btn.classList.add("active") : btn.classList.remove("active")
                       })

        if (event.detail.message && event.detail.message !== "")
        {
            Toaster.fire(event.detail.message)
        }

    }

    async getFavourites ()
    {
        if (window.__USER__ === null)
        {
            return [];
        }

        let response = await axios.get("/endpoints/user/favourites");



        return response.data;
    }

    onShowUserFavourite (e)
    {
/*console.log(('onShowUserFavourite', e))*/;        this.showAddResource(e.detail.id);
    }

    onFavouriteClick (btn, event)
    {
        let button = btn.closest("button");

        if (window.__USER__ === null)
        {
            let btnUser = document.querySelector("#header-link-user");
            btnUser.click();
            return;
        }
        else
        {
            let id = button.attributes["data-resource-id"].value;
            this.showAddResource(id);


        }
    }

    showAddResource (id)
    {
        if (!this.userDialog) //first time
        {
            this.userDialog = document.querySelector("#dialog_login");

            this.userDialog.addEventListener("click", (e) =>
            {
                //clicking on the backdrop let us close the modal
                if (!e.target.closest("div"))
                {
                    //e.target.close();
                    window.__login__.close();
                }
            })
        }

        if (window.__login__)
        {
            window.__login__.show("add-resource", id );
        }
    }

}
